import ToggleSwitch from 'components/atoms/form/ToggleSwitch/ToggleSwitch'
import MultiCard from 'components/molecules/Card/MultiCard'
import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import { Form, Formik } from 'formik'
import 'moment-timezone'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import CountryService from 'services/CountryService'
import { areObjectStringsEqual, isArrayNotEmpty, isObjectEmpty, searchFirstObjectInList, setHotelInfoInSession, sortObjectList } from 'utilities/JSUtil'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import timezoneList from '../../../../constants/TimezoneConst'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import HotelInfoService from '../../../../services/HotelInfoService'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import SelectInput from '../../../atoms/form/SelectInput/SelectInput'
import TextInput from '../../../atoms/form/TextInput/TextInput'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './HotelInfo.scss'

class HotelInfo extends Component {

    constructor(props) {
        super(props)
        let hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        let hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        let hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)
        const user = getSessionItem(SessionConst.USER)

        if (!hotelCode || isObjectEmpty(hotelInfo) || isObjectEmpty(user)) {
            // Go home
            this.props.history.replace(RouteConst.ROUTE_HOME_PAGE)
        }

        const isHotelDomestic = getSessionItem(SessionConst.IS_HOTEL_DOMESTIC) === FormConst.VALUE_NO ? false : true
        const brandCode = hotelInfo.brandCode
        const productCode = hotelInfo.productCode

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            brandCode: brandCode,
            productCode: productCode,
            user: user,
            isHotelDomestic: isHotelDomestic,
            initialValues: this.initialValues,
            timezoneOptions: timezoneList,
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            showResetModal: false,
            showErrorModal: false,
            currencyOptions: [{ label: 'USD', value: 'USD' }],
            hotelInfoCompletedHistory: hotelInfoCompletedHistory
        }
    }

    // Days of week for Office Hours
    daysOfWeek = {
        'mon': 'Monday',
        'tue': 'Tuesday',
        'wed': 'Wednesday',
        'thur': 'Thursday',
        'fri': 'Friday',
        'sat': 'Saturday',
        'sun': 'Sunday'
    }

    // Default initial values for formik
    initialValues = {
        phoneNumber: '',
        areaCode: '',
        countryCode: '',
        phoneNumberType: FormConst.VALUE_PRIMARY,
        faxPhoneNumber: '',
        faxAreaCode: '',
        faxCountryCode: '',
        faxPhoneNumberType: FormConst.VALUE_FAX,
        email: '',
        emailType: FormConst.HOTEL_INFO_DEFAULT_EMAIL_TYPE,
        generalManagerFirstName: '',
        generalManagerLastName: '',
        salesManagerFirstName: '',
        salesManagerLastName: '',
        numberOfRooms: '',
        numberOfFloors: '',
        hotelOpeningType: '',
        hotelOpeningDate: '',
        checkInTime: FormConst.HOTEL_CHECK_IN_TIME_DEFAULT,
        checkOutTime: FormConst.HOTEL_CHECK_OUT_TIME_DEFAULT,
        isChildrenStayFree: false,
        maxChildAge: '',
        isTravelAgentCommission: false,
        travelAgentCommission: '',
        isIncludeTaxes: false,
        hotelCurrency: '',
        hotelTimezone: '',
        isLOSTiers: false,
        ratePlanConfigurationType: FormConst.RATE_PLAN_CONFIGURATION_TYPE_STANDARD_VALUE,
        officeHoursConfig: FormConst.VALUE_OFFICE_HOURS_OPEN,
        isOfficeHoursSameAllDOW: true,
        commonOperatingHoursOpen: '',
        commonOperatingHoursClose: '',
        mon24Config: FormConst.VALUE_OFFICE_HOURS_OPEN,
        tue24Config: FormConst.VALUE_OFFICE_HOURS_OPEN,
        wed24Config: FormConst.VALUE_OFFICE_HOURS_OPEN,
        thur24Config: FormConst.VALUE_OFFICE_HOURS_OPEN,
        fri24Config: FormConst.VALUE_OFFICE_HOURS_OPEN,
        sat24Config: FormConst.VALUE_OFFICE_HOURS_OPEN,
        sun24Config: FormConst.VALUE_OFFICE_HOURS_OPEN,
        isOfficeHoursConfigurable: false
    }

    // Validation schema for form fields
    validationSchema = Yup.object().shape({
        countryCode: Yup.string()
            .required(FormConst.VALIDATION_ERROR_REQUIRED)
            .matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
            .max(FormConst.MAX_LENGTH_COUNTRY_CODE, `Maximum ${FormConst.MAX_LENGTH_COUNTRY_CODE} digits`),
        areaCode: Yup.string()
            .required(FormConst.VALIDATION_ERROR_REQUIRED)
            .matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
            .max(FormConst.MAX_LENGTH_AREA_CODE, `Maximum ${FormConst.MAX_LENGTH_AREA_CODE} digits`),
        phoneNumber: Yup.string()
            .required(FormConst.VALIDATION_ERROR_REQUIRED)
            .matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
            .max(FormConst.MAX_LENGTH_PHONE_NUMBER, `Maximum ${FormConst.MAX_LENGTH_PHONE_NUMBER} digits`),
        faxCountryCode: Yup.string()
            .required(FormConst.VALIDATION_ERROR_REQUIRED)
            .matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
            .max(FormConst.MAX_LENGTH_COUNTRY_CODE, `Maximum ${FormConst.MAX_LENGTH_COUNTRY_CODE} digits`),
        faxAreaCode: Yup.string()
            .required(FormConst.VALIDATION_ERROR_REQUIRED)
            .matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
            .max(FormConst.MAX_LENGTH_AREA_CODE, `Maximum ${FormConst.MAX_LENGTH_AREA_CODE} digits`),
        faxPhoneNumber: Yup.string()
            .required(FormConst.VALIDATION_ERROR_REQUIRED)
            .matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
            .max(FormConst.MAX_LENGTH_PHONE_NUMBER, `Maximum ${FormConst.MAX_LENGTH_PHONE_NUMBER} digits`),
        generalManagerFirstName: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS),
        generalManagerLastName: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS),
        // Sales manager last name is required when first name is present
        salesManagerLastName: Yup.string().matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS)
            .test('Sales Manager last name is required when first name is present', FormConst.VALIDATION_ERROR_REQUIRED, function (val) {
                return !!this.parent.salesManagerFirstName ? !!val : true
            }),
        // Sales manager first name is required when last name is present
        salesManagerFirstName: Yup.string().matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS)
            .when('salesManagerLastName', {
                is: (salesManagerLastName) => !!salesManagerLastName,
                then: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
            }),
        femaId: Yup.string().matches(FormConst.FEMA_ID_PATTERN, FormConst.VALIDATION_ERROR_FEMA_ID_FORMAT),
        numberOfRooms: Yup.number().required(FormConst.VALIDATION_ERROR_REQUIRED).min(1, FormConst.VALIDATION_ERROR_NUMBER_GREATER_THAN_ZERO),
        numberOfFloors: Yup.number().required(FormConst.VALIDATION_ERROR_REQUIRED).min(1, FormConst.VALIDATION_ERROR_NUMBER_GREATER_THAN_ZERO),
        hotelOpeningType: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
        hotelOpeningDate: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED).matches(FormConst.DATE_PATTERN, FormConst.VALIDATION_ERROR_DATE_PATTERN),
        hotelTimezone: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
        checkInTime: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED).matches(FormConst.TIME_24H_PATTERN, FormConst.VALIDATION_ERROR_TIME_PATTERN),
        checkOutTime: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED).matches(FormConst.TIME_24H_PATTERN, FormConst.VALIDATION_ERROR_TIME_PATTERN),
        isChildrenStayFree: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED),
        // maxChildAge is required when isChildrenStayFree is true
        maxChildAge: Yup.number()
            .when('isChildrenStayFree', {
                is: (isChildrenStayFree) => isChildrenStayFree === true,
                then: Yup.number().typeError(FormConst.VALIDATION_ERROR_TYPE_NUMBER).required(FormConst.VALIDATION_ERROR_REQUIRED).min(1, FormConst.VALIDATION_ERROR_NUMBER_GREATER_THAN_ZERO),
            }),
        isTravelAgentCommission: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED),
        // travelAgentCommission is required when isTravelAgentCommission is true
        travelAgentCommission: Yup.number()
            .when('isTravelAgentCommission', {
                is: (isTravelAgentCommission) => isTravelAgentCommission === true,
                then: Yup.number().typeError(FormConst.VALIDATION_ERROR_TYPE_NUMBER).required(FormConst.VALIDATION_ERROR_REQUIRED).min(1, FormConst.VALIDATION_ERROR_NUMBER_GREATER_THAN_ZERO),
            }),
        isIncludeTaxes: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED),
        hotelCurrency: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
        officeHoursConfig: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
        isOfficeHoursSameAllDOW: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED),
        // Common operating hours are required when office hours are same for all days of week
        commonOperatingHoursOpen: Yup.string()
            .when(['officeHoursConfig', 'isOfficeHoursSameAllDOW'], {
                is: (officeHoursConfig, isOfficeHoursSameAllDOW) => {
                    return officeHoursConfig === FormConst.VALUE_OFFICE_HOURS_OTHER && isOfficeHoursSameAllDOW
                },
                then: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            }),
        commonOperatingHoursClose: Yup.string()
            .when(['officeHoursConfig', 'isOfficeHoursSameAllDOW'], {
                is: (officeHoursConfig, isOfficeHoursSameAllDOW) => officeHoursConfig === FormConst.VALUE_OFFICE_HOURS_OTHER && isOfficeHoursSameAllDOW,
                then: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            }),
        // Specific day of week config is required when office hours config is Other - not Open 24/7 or Closed 24/7
        mon24Config: Yup.string()
            .when(['officeHoursConfig', 'isOfficeHoursSameAllDOW'], {
                is: (officeHoursConfig, isOfficeHoursSameAllDOW) => {
                    return officeHoursConfig === FormConst.VALUE_OFFICE_HOURS_OTHER && !isOfficeHoursSameAllDOW
                },
                then: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            }),
        tue24Config: Yup.string()
            .when(['officeHoursConfig', 'isOfficeHoursSameAllDOW'], {
                is: (officeHoursConfig, isOfficeHoursSameAllDOW) => {
                    return officeHoursConfig === FormConst.VALUE_OFFICE_HOURS_OTHER && !isOfficeHoursSameAllDOW
                },
                then: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            }),
        wed24Config: Yup.string()
            .when(['officeHoursConfig', 'isOfficeHoursSameAllDOW'], {
                is: (officeHoursConfig, isOfficeHoursSameAllDOW) => {
                    return officeHoursConfig === FormConst.VALUE_OFFICE_HOURS_OTHER && !isOfficeHoursSameAllDOW
                },
                then: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            }),
        thur24Config: Yup.string()
            .when(['officeHoursConfig', 'isOfficeHoursSameAllDOW'], {
                is: (officeHoursConfig, isOfficeHoursSameAllDOW) => {
                    return officeHoursConfig === FormConst.VALUE_OFFICE_HOURS_OTHER && !isOfficeHoursSameAllDOW
                },
                then: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            }),
        fri24Config: Yup.string()
            .when(['officeHoursConfig', 'isOfficeHoursSameAllDOW'], {
                is: (officeHoursConfig, isOfficeHoursSameAllDOW) => {
                    return officeHoursConfig === FormConst.VALUE_OFFICE_HOURS_OTHER && !isOfficeHoursSameAllDOW
                },
                then: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            }),
        sat24Config: Yup.string()
            .when(['officeHoursConfig', 'isOfficeHoursSameAllDOW'], {
                is: (officeHoursConfig, isOfficeHoursSameAllDOW) => {
                    return officeHoursConfig === FormConst.VALUE_OFFICE_HOURS_OTHER && !isOfficeHoursSameAllDOW
                },
                then: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            }),
        sun24Config: Yup.string()
            .when(['officeHoursConfig', 'isOfficeHoursSameAllDOW'], {
                is: (officeHoursConfig, isOfficeHoursSameAllDOW) => {
                    return officeHoursConfig === FormConst.VALUE_OFFICE_HOURS_OTHER && !isOfficeHoursSameAllDOW
                },
                then: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            }),
        // Day of week operation hours are required when config for that day is Other - not Open 24/7 or Closed 24/7
        monOperatingHours: Yup.object()
            .when(['officeHoursConfig', 'isOfficeHoursSameAllDOW', 'mon24Config'], {
                is: (officeHoursConfig, isOfficeHoursSameAllDOW, mon24Config) =>
                    officeHoursConfig === FormConst.VALUE_OFFICE_HOURS_OTHER && !isOfficeHoursSameAllDOW && mon24Config === FormConst.VALUE_OFFICE_HOURS_OTHER,
                then: Yup.object().shape({
                    open: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
                    close: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
                })
            }),
        tueOperatingHours: Yup.object()
            .when(['officeHoursConfig', 'isOfficeHoursSameAllDOW', 'tue24Config'], {
                is: (officeHoursConfig, isOfficeHoursSameAllDOW, tue24Config) =>
                    officeHoursConfig === FormConst.VALUE_OFFICE_HOURS_OTHER && !isOfficeHoursSameAllDOW && tue24Config === FormConst.VALUE_OFFICE_HOURS_OTHER,
                then: Yup.object().shape({
                    open: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
                    close: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
                })
            }),
        wedOperatingHours: Yup.object()
            .when(['officeHoursConfig', 'isOfficeHoursSameAllDOW', 'wed24Config'], {
                is: (officeHoursConfig, isOfficeHoursSameAllDOW, wed24Config) =>
                    officeHoursConfig === FormConst.VALUE_OFFICE_HOURS_OTHER && !isOfficeHoursSameAllDOW && wed24Config === FormConst.VALUE_OFFICE_HOURS_OTHER,
                then: Yup.object().shape({
                    open: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
                    close: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
                })
            }),
        thurOperatingHours: Yup.object()
            .when(['officeHoursConfig', 'isOfficeHoursSameAllDOW', 'thur24Config'], {
                is: (officeHoursConfig, isOfficeHoursSameAllDOW, thur24Config) =>
                    officeHoursConfig === FormConst.VALUE_OFFICE_HOURS_OTHER && !isOfficeHoursSameAllDOW && thur24Config === FormConst.VALUE_OFFICE_HOURS_OTHER,
                then: Yup.object().shape({
                    open: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
                    close: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
                })
            }),
        friOperatingHours: Yup.object()
            .when(['officeHoursConfig', 'isOfficeHoursSameAllDOW', 'fri24Config'], {
                is: (officeHoursConfig, isOfficeHoursSameAllDOW, fri24Config) =>
                    officeHoursConfig === FormConst.VALUE_OFFICE_HOURS_OTHER && !isOfficeHoursSameAllDOW && fri24Config === FormConst.VALUE_OFFICE_HOURS_OTHER,
                then: Yup.object().shape({
                    open: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
                    close: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
                })
            }),
        satOperatingHours: Yup.object()
            .when(['officeHoursConfig', 'isOfficeHoursSameAllDOW', 'sat24Config'], {
                is: (officeHoursConfig, isOfficeHoursSameAllDOW, sat24Config) =>
                    officeHoursConfig === FormConst.VALUE_OFFICE_HOURS_OTHER && !isOfficeHoursSameAllDOW && sat24Config === FormConst.VALUE_OFFICE_HOURS_OTHER,
                then: Yup.object().shape({
                    open: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
                    close: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
                })
            }),
        sunOperatingHours: Yup.object()
            .when(['officeHoursConfig', 'isOfficeHoursSameAllDOW', 'sun24Config'], {
                is: (officeHoursConfig, isOfficeHoursSameAllDOW, sun24Config) =>
                    officeHoursConfig === FormConst.VALUE_OFFICE_HOURS_OTHER && !isOfficeHoursSameAllDOW && sun24Config === FormConst.VALUE_OFFICE_HOURS_OTHER,
                then: Yup.object().shape({
                    open: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
                    close: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
                })
            })
    })

    /**
     * Lifecycle method that runs after the component mounts. Gets data from the service and sets initial values for the form.
     */
    async componentDidMount() {
        // Get country service data for building currency options
        // Get hotel info response and build initial values for form
    	
    	 if (this.state.hotelInfoCompletedHistory.newEntity && this.state.hotelInfoCompletedHistory.newEntity.status === "COMPLETED") {
    		 let hotelInfoFromSession = this.state.hotelInfoCompletedHistory.newEntity.hotelInfo
    		 this.setState({
                 hotelInfo: hotelInfoFromSession,
                 isLoading: false,
                 initialValues: this.buildFormValues(hotelInfoFromSession),
                 currencyOptions: [{ label: hotelInfoFromSession.currencyCode, value: hotelInfoFromSession.currencyCode }]
             })
	    } else {
	        await CountryService.getCountries({ hotelCode: this.state.hotelCode })
	            .then(async countryServiceResponse => {
	                await HotelInfoService.getHotelInfo({ hotelCode: this.state.hotelCode })
	                    .then(hotelInfoResponse => {
                        // Build currency options. Always include hotel currency when available,
                        // then append valid country currencies in a deduped list.
                        const countriesList = countryServiceResponse?.countries || []
                        const countries = sortObjectList([...(countriesList || [])], 'currencyCode')
                        const hotelCountry = hotelInfoResponse?.address?.country
                        const hotelCurrency = hotelInfoResponse?.currencyCode?.trim()
                        const currencySet = new Set()

                        if (hotelCurrency) {
                            currencySet.add(hotelCurrency)
                        }

                        if (isArrayNotEmpty(countries)) {
                            if (hotelCountry) {
                                const hotelCountryCurrency = countries.find(country => country.iso2Code === hotelCountry)?.currencyCode?.trim()
                                if (hotelCountryCurrency) {
                                    currencySet.add(hotelCountryCurrency)
                                }
                            }

                            countries.forEach(country => {
                                const currencyCode = country?.currencyCode?.trim()
                                if (currencyCode) {
                                    currencySet.add(currencyCode)
                                }
                            })
                        }

                        if (currencySet.size === 0) {
                            currencySet.add('USD')
                        }

                        const currencyOptions = Array.from(currencySet).map(currencyOption => {
                            return {
                                label: currencyOption,
                                value: currencyOption
                            }
                        })

                        this.setState({
                            hotelInfo: hotelInfoResponse,
                            isLoading: false,
                            initialValues: this.buildFormValues(hotelInfoResponse),
                            currencyOptions: currencyOptions,
                            countries: countriesList
                        })
                    }).catch(error => {
                        this.setState({
                            isLoading: false,
                            showErrorModal: true,
                            errorMessage: 'Error while reading Hotel Info data'
                        })
                    })
	            }).catch(error => {
	                this.setState({
	                    isLoading: false,
	                    showErrorModal: true,
	                    errorMessage: 'Error while reading Country data'
	                })
	            })
	    }
    }

    /**
     * Builds form values from the service response
     * 
     * @param {Object} hotelInfo The Hotel Info object from the service response
     * @returns {Object} the initial values for the form
     */
    buildFormValues = (hotelInfo) => {
        let phoneNumber = ''
        let areaCode = ''
        let countryCode = ''
        let phoneNumberType = FormConst.VALUE_PRIMARY
        let faxPhoneNumber = ''
        let faxAreaCode = ''
        let faxCountryCode = ''
        let faxPhoneNumberType = FormConst.VALUE_FAX
        let email = ''
        let emailType = FormConst.HOTEL_INFO_DEFAULT_EMAIL_TYPE

        if (isArrayNotEmpty(hotelInfo.phones)) {
            let phoneObject = searchFirstObjectInList('type', phoneNumberType, hotelInfo.phones)
            if (!isObjectEmpty(phoneObject)) {
                areaCode = phoneObject.areaCode
                phoneNumber = phoneObject.phoneNumber
                countryCode = phoneObject.countryAccessCode
            }

            let faxObject = searchFirstObjectInList('type', faxPhoneNumberType, hotelInfo.phones)
            if (!isObjectEmpty(faxObject)) {
                faxAreaCode = faxObject.areaCode
                faxPhoneNumber = faxObject.phoneNumber
                faxCountryCode = faxObject.countryAccessCode
            }
        }

        if (hotelInfo.email) {
            let emailObject = hotelInfo.email
            email = emailObject.address
        }

        // Timezone
        let hotelTimezone = ''
        if (!isObjectEmpty(hotelInfo.timezone)) {
            hotelTimezone = hotelInfo.timezone.timezoneLocation
        }
        // Office Hours, Linked Rate plan configuration and use LOS Tiers are brand specific
        const isOfficeHoursConfigurable = FormConst.BRANDS_ALLOW_OFFICE_HOURS_CONFIG.includes(this.state.brandCode)
        const isLinkedRateplanConfig = FormConst.BRANDS_USE_LINKED_RATEPLAN_CONFIGURATION.includes(this.state.brandCode) ? true : false
        const isMultiTierConfig = FormConst.BRANDS_USE_MULTI_TIER_CONFIGURATION.includes(this.state.brandCode) ? true : false

        const isLosTiers = hotelInfo.useLosTiers !== undefined
            ? hotelInfo.useLosTiers
            : isMultiTierConfig ? true : false

        const rateplanConfigurationType = hotelInfo.ratePlanConfigurationType !== undefined
            ? hotelInfo.ratePlanConfigurationType
            : isLinkedRateplanConfig
                ? FormConst.RATE_PLAN_CONFIGURATION_TYPE_LINKED_VALUE
                : FormConst.RATE_PLAN_CONFIGURATION_TYPE_STANDARD_VALUE

        // Only Admin users have the option to change rate plan configuration type
        // It is allowed only for multi tier brands
        const isRatePlanConfigurationAvailable = this.state.user.isAdmin && isMultiTierConfig

        let initialValues = {
            phoneNumber: phoneNumber,
            areaCode: areaCode,
            countryCode: countryCode,
            phoneNumberType: phoneNumberType,
            faxPhoneNumber: faxPhoneNumber,
            faxAreaCode: faxAreaCode,
            faxCountryCode: faxCountryCode,
            faxPhoneNumberType: faxPhoneNumberType,
            email: email,
            emailType: emailType,
            generalManagerFirstName: hotelInfo.generalManager?.givenName || '',
            generalManagerLastName: hotelInfo.generalManager?.surName || '',
            salesManagerFirstName: hotelInfo.salesManager?.givenName || '',
            salesManagerLastName: hotelInfo.salesManager?.surName || '',
            femaId: hotelInfo.femaId,
            numberOfRooms: hotelInfo.guestRooms,
            numberOfFloors: hotelInfo.floors,
            hotelOpeningType: hotelInfo.openingType,
            hotelOpeningDate: hotelInfo.openingDate,
            hotelTimezone: hotelTimezone,
            checkInTime: hotelInfo.checkInTime || FormConst.HOTEL_CHECK_IN_TIME_DEFAULT,
            checkOutTime: hotelInfo.checkOutTime || FormConst.HOTEL_CHECK_OUT_TIME_DEFAULT,
            isChildrenStayFree: this.state.isHotelDomestic
                ? FormConst.CHILDREN_STAY_FREE_DOMESTIC_DEFAULT
                : (hotelInfo.childrenStayFree !== undefined ? hotelInfo.childrenStayFree : FormConst.CHILDREN_STAY_FREE_INTERNATIONAL_DEFAULT),
            maxChildAge: this.state.isHotelDomestic
                ? FormConst.MAX_CHILD_AGE_DOMESTIC_DEFAULT
                : (hotelInfo.ageChildStaysFree !== undefined ? hotelInfo.ageChildStaysFree : FormConst.MAX_CHILD_AGE_INTERNATIONAL_DEFAULT),
            isTravelAgentCommission: this.state.isHotelDomestic
                ? FormConst.IS_TRAVEL_AGENT_COMMISSION_DOMESTIC_DEFAULT
                : (hotelInfo.travelAgentCommission !== undefined ? hotelInfo.travelAgentCommission.enabled : FormConst.IS_TRAVEL_AGENT_COMMISSION_INTERNATIONAL_DEFAULT),
            travelAgentCommission: this.state.isHotelDomestic
                ? FormConst.TRAVEL_AGENT_COMMISSION_DOMESTIC_DEFAULT
                : (hotelInfo.travelAgentCommission !== undefined ? hotelInfo.travelAgentCommission.percentage : FormConst.TRAVEL_AGENT_COMMISSION_INTERNATIONAL_DEFAULT),
            isIncludeTaxes: this.state.isHotelDomestic
                ? FormConst.TAXES_INCLUDED_IN_RATES_DOMESTIC_DEFAULT
                : (hotelInfo.taxInclusive !== undefined ? hotelInfo.taxInclusive : FormConst.TAXES_INCLUDED_IN_RATES_INTERNATIONAL_DEFAULT),
            hotelCurrency: hotelInfo.currencyCode,
            isLOSTiers: isLosTiers,
            ratePlanConfigurationType: rateplanConfigurationType,
            isRatePlanConfigurationAvailable: isRatePlanConfigurationAvailable,
            isOfficeHoursConfigurable: isOfficeHoursConfigurable,
            isOfficeOpenAllDays: isOfficeHoursConfigurable
                ? (hotelInfo.officeOpenAllDays === false ? false : true)
                : FormConst.IS_OFFICE_HOURS_OPEN_ALL_DAYS_DEFAULT,
            monOperatingHours: hotelInfo.officeHours?.monOperatingHours || {
                open: '',
                close: ''
            },
            tueOperatingHours: hotelInfo.officeHours?.tueOperatingHours || {
                open: '',
                close: ''
            },
            wedOperatingHours: hotelInfo.officeHours?.wedOperatingHours || {
                open: '',
                close: ''
            },
            thurOperatingHours: hotelInfo.officeHours?.thurOperatingHours || {
                open: '',
                close: ''
            },
            friOperatingHours: hotelInfo.officeHours?.friOperatingHours || {
                open: '',
                close: ''
            },
            satOperatingHours: hotelInfo.officeHours?.satOperatingHours || {
                open: '',
                close: ''
            },
            sunOperatingHours: hotelInfo.officeHours?.sunOperatingHours || {
                open: '',
                close: ''
            }
        }

        const isOfficeClosedAllDays = hotelInfo.officeHours?.mon24Close
            && hotelInfo.officeHours?.tue24Close
            && hotelInfo.officeHours?.wed24Close
            && hotelInfo.officeHours?.thur24Close
            && hotelInfo.officeHours?.fri24Close
            && hotelInfo.officeHours?.sat24Close
            && hotelInfo.officeHours?.sun24Close

        initialValues.officeHoursConfig = initialValues.isOfficeOpenAllDays ? FormConst.VALUE_OFFICE_HOURS_OPEN : (isOfficeClosedAllDays ? FormConst.VALUE_OFFICE_HOURS_CLOSED : FormConst.VALUE_OFFICE_HOURS_OTHER)

        initialValues.isOfficeHoursSameAllDOW = initialValues.isOfficeOpenAllDays || isOfficeClosedAllDays
            || (!areObjectStringsEqual(initialValues.monOperatingHours, { open: '', close: '' })
                && areObjectStringsEqual(initialValues.monOperatingHours, initialValues.tueOperatingHours)
                && areObjectStringsEqual(initialValues.monOperatingHours, initialValues.wedOperatingHours)
                && areObjectStringsEqual(initialValues.monOperatingHours, initialValues.thurOperatingHours)
                && areObjectStringsEqual(initialValues.monOperatingHours, initialValues.friOperatingHours)
                && areObjectStringsEqual(initialValues.monOperatingHours, initialValues.satOperatingHours)
                && areObjectStringsEqual(initialValues.monOperatingHours, initialValues.sunOperatingHours))

        initialValues.mon24Config = hotelInfo.officeHours?.mon24Open ? FormConst.VALUE_OFFICE_HOURS_OPEN : (hotelInfo.officeHours?.mon24Close ? FormConst.VALUE_OFFICE_HOURS_CLOSED : FormConst.VALUE_OFFICE_HOURS_OTHER)
        initialValues.tue24Config = hotelInfo.officeHours?.tue24Open ? FormConst.VALUE_OFFICE_HOURS_OPEN : (hotelInfo.officeHours?.tue24Close ? FormConst.VALUE_OFFICE_HOURS_CLOSED : FormConst.VALUE_OFFICE_HOURS_OTHER)
        initialValues.wed24Config = hotelInfo.officeHours?.wed24Open ? FormConst.VALUE_OFFICE_HOURS_OPEN : (hotelInfo.officeHours?.wed24Close ? FormConst.VALUE_OFFICE_HOURS_CLOSED : FormConst.VALUE_OFFICE_HOURS_OTHER)
        initialValues.thur24Config = hotelInfo.officeHours?.thur24Open ? FormConst.VALUE_OFFICE_HOURS_OPEN : (hotelInfo.officeHours?.thur24Close ? FormConst.VALUE_OFFICE_HOURS_CLOSED : FormConst.VALUE_OFFICE_HOURS_OTHER)
        initialValues.fri24Config = hotelInfo.officeHours?.fri24Open ? FormConst.VALUE_OFFICE_HOURS_OPEN : (hotelInfo.officeHours?.fri24Close ? FormConst.VALUE_OFFICE_HOURS_CLOSED : FormConst.VALUE_OFFICE_HOURS_OTHER)
        initialValues.sat24Config = hotelInfo.officeHours?.sat24Open ? FormConst.VALUE_OFFICE_HOURS_OPEN : (hotelInfo.officeHours?.sat24Close ? FormConst.VALUE_OFFICE_HOURS_CLOSED : FormConst.VALUE_OFFICE_HOURS_OTHER)
        initialValues.sun24Config = hotelInfo.officeHours?.sun24Open ? FormConst.VALUE_OFFICE_HOURS_OPEN : (hotelInfo.officeHours?.sun24Close ? FormConst.VALUE_OFFICE_HOURS_CLOSED : FormConst.VALUE_OFFICE_HOURS_OTHER)

        initialValues.commonOperatingHoursOpen = initialValues.isOfficeHoursSameAllDOW
            ? hotelInfo.officeHours?.monOperatingHours?.open : ''

        initialValues.commonOperatingHoursClose = initialValues.isOfficeHoursSameAllDOW
            ? hotelInfo.officeHours?.monOperatingHours?.close : ''

        return initialValues
    }

    /**
     * Builds the object to be used in service call from the form data
     * 
     * @param {Object} formData 
     * @returns {Object} The data to be used for PUT
     */
    buildPutData = (formData) => {
        let salesManager

        if (formData.salesManagerFirstName || formData.salesManagerLastName) {
            salesManager = {
                givenName: formData.salesManagerFirstName,
                surName: formData.salesManagerLastName
            }
        }

        let officeHours
        let officeOpenAllDays = false

        if (formData.officeHoursConfig === FormConst.VALUE_OFFICE_HOURS_OPEN) {
            officeOpenAllDays = true
            officeHours = {
                mon24Open: true,
                tue24Open: true,
                wed24Open: true,
                thur24Open: true,
                fri24Open: true,
                sat24Open: true,
                sun24Open: true
            }
        } else if (formData.officeHoursConfig === FormConst.VALUE_OFFICE_HOURS_CLOSED) {
            officeHours = {
                mon24Close: true,
                tue24Close: true,
                wed24Close: true,
                thur24Close: true,
                fri24Close: true,
                sat24Close: true,
                sun24Close: true
            }
        } else {
            if (formData.isOfficeHoursSameAllDOW) {
                let hours = {
                    open: formData.commonOperatingHoursOpen,
                    close: formData.commonOperatingHoursClose
                }
                officeHours = {
                    monOperatingHours: { ...hours },
                    tueOperatingHours: { ...hours },
                    wedOperatingHours: { ...hours },
                    thurOperatingHours: { ...hours },
                    friOperatingHours: { ...hours },
                    satOperatingHours: { ...hours },
                    sunOperatingHours: { ...hours }
                }
                officeOpenAllDays = false
            } else {
                officeHours = {
                    mon24Open: formData.mon24Config === FormConst.VALUE_OFFICE_HOURS_OPEN ? true : undefined,
                    mon24Close: formData.mon24Config === FormConst.VALUE_OFFICE_HOURS_CLOSED ? true : undefined,
                    monOperatingHours: formData.mon24Config === FormConst.VALUE_OFFICE_HOURS_OTHER ? formData.monOperatingHours : undefined,
                    tue24Open: formData.tue24Config === FormConst.VALUE_OFFICE_HOURS_OPEN ? true : undefined,
                    tue24Close: formData.tue24Config === FormConst.VALUE_OFFICE_HOURS_CLOSED ? true : undefined,
                    tueOperatingHours: formData.tue24Config === FormConst.VALUE_OFFICE_HOURS_OTHER ? formData.tueOperatingHours : undefined,
                    wed24Open: formData.wed24Config === FormConst.VALUE_OFFICE_HOURS_OPEN ? true : undefined,
                    wed24Close: formData.wed24Config === FormConst.VALUE_OFFICE_HOURS_CLOSED ? true : undefined,
                    wedOperatingHours: formData.wed24Config === FormConst.VALUE_OFFICE_HOURS_OTHER ? formData.wedOperatingHours : undefined,
                    thur24Open: formData.thur24Config === FormConst.VALUE_OFFICE_HOURS_OPEN ? true : undefined,
                    thur24Close: formData.thur24Config === FormConst.VALUE_OFFICE_HOURS_CLOSED ? true : undefined,
                    thurOperatingHours: formData.thur24Config === FormConst.VALUE_OFFICE_HOURS_OTHER ? formData.thurOperatingHours : undefined,
                    fri24Open: formData.fri24Config === FormConst.VALUE_OFFICE_HOURS_OPEN ? true : undefined,
                    fri24Close: formData.fri24Config === FormConst.VALUE_OFFICE_HOURS_CLOSED ? true : undefined,
                    friOperatingHours: formData.fri24Config === FormConst.VALUE_OFFICE_HOURS_OTHER ? formData.friOperatingHours : undefined,
                    sat24Open: formData.sat24Config === FormConst.VALUE_OFFICE_HOURS_OPEN ? true : undefined,
                    sat24Close: formData.sat24Config === FormConst.VALUE_OFFICE_HOURS_CLOSED ? true : undefined,
                    satOperatingHours: formData.sat24Config === FormConst.VALUE_OFFICE_HOURS_OTHER ? formData.satOperatingHours : undefined,
                    sun24Open: formData.sun24Config === FormConst.VALUE_OFFICE_HOURS_OPEN ? true : undefined,
                    sun24Close: formData.sun24Config === FormConst.VALUE_OFFICE_HOURS_CLOSED ? true : undefined,
                    sunOperatingHours: formData.sun24Config === FormConst.VALUE_OFFICE_HOURS_OTHER ? formData.sunOperatingHours : undefined
                }

                officeOpenAllDays = officeHours.mon24Config === FormConst.VALUE_OFFICE_HOURS_OPEN
                    && officeHours.tue24Config === FormConst.VALUE_OFFICE_HOURS_OPEN && officeHours.wed24Config === FormConst.VALUE_OFFICE_HOURS_OPEN
                    && officeHours.thur24Config === FormConst.VALUE_OFFICE_HOURS_OPEN && officeHours.fri24Config === FormConst.VALUE_OFFICE_HOURS_OPEN
                    && officeHours.sat24Config === FormConst.VALUE_OFFICE_HOURS_OPEN && officeHours.sun24Config === FormConst.VALUE_OFFICE_HOURS_OPEN
            }
        }

        // Build timezone
        const timezoneObject = searchFirstObjectInList('value', formData.hotelTimezone, timezoneList)
        const timezone = {
            gmtOffset: timezoneObject?.offset,
            timezoneLocation: timezoneObject?.value,
            observesDaylightSavingsTime: timezoneObject?.observesDaylightSavingsTime
        }

        let putData = {
            phones: [{
                type: formData.phoneNumberType,
                countryAccessCode: formData.countryCode,
                areaCode: formData.areaCode,
                phoneNumber: formData.phoneNumber
            },
            {
                type: formData.faxPhoneNumberType,
                countryAccessCode: formData.faxCountryCode,
                areaCode: formData.faxAreaCode,
                phoneNumber: formData.faxPhoneNumber
            }],
            email: {
                address: formData.email,
                type: formData.emailType,
                preferred: new Boolean(true)
            },
            checkInTime: formData.checkInTime,
            checkOutTime: formData.checkOutTime,
            generalManager: {
                givenName: formData.generalManagerFirstName,
                surName: formData.generalManagerLastName
            },
            salesManager: salesManager,
            femaId: formData.femaId,
            childrenStayFree: formData.isChildrenStayFree,
            ageChildStaysFree: formData.isChildrenStayFree ? (formData.maxChildAge ? formData.maxChildAge : undefined) : undefined,
            travelAgentCommission: {
                enabled: formData.isTravelAgentCommission,
                percentage: formData.isTravelAgentCommission ? formData.travelAgentCommission : undefined
            },
            currencyCode: formData.hotelCurrency,
            taxInclusive: formData.isIncludeTaxes,
            guestRooms: formData.numberOfRooms,
            floors: formData.numberOfFloors,
            openingType: formData.hotelOpeningType,
            openingDate: formData.hotelOpeningDate,
            timezone: timezone,
            useLosTiers: formData.isLOSTiers,
            ratePlanConfigurationType: formData.ratePlanConfigurationType,
            officeOpenAllDays: officeOpenAllDays,
            officeHours: officeHours
        }

        return putData
    }

    handleSubmit = (data) => {
        let putData = this.buildPutData({ ...data })
        this.props.onPut({ hotelCode: this.state.hotelCode, formData: putData })
        this.setState({
            // Modal details
            isLoading: true,
            loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT,
            // Used to update session if put is successful
            pendingHotelInfo: putData,
            // Determines what to do in componentDidUpdate
            actionPerformed: FormConst.ACTION_PUT
        })
    }

    /**
     * Displays reset modal
     */
    handleClearForm = () => {
        this.setState({ showResetModal: true })
    }

    /**
     * Resets form data and hides the reset modal
     * @param {Function} formikResetFormMethod 
     */
    resetFormData = (formikResetFormMethod) => {
        formikResetFormMethod()
        this.setState({
            showResetModal: false
        })
    }

    /**
     * Lifecycle method to handle this component's update. Only handles updates which are a result of HTTP async actions.
     * 
     * @param {Object} prevProps properties before the current update
     */
    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({ isLoading: false, showErrorModal: true, errorMessage: this.props.errorDescription })
            } else {
                if (this.state.actionPerformed === FormConst.ACTION_PUT) {
                    // If a PUT request was submitted, update the hotel info with the pending put object
                    const updatedHotelInfo = {
                        ...this.state.hotelInfo,
                        ...this.state.pendingHotelInfo
                    }
                    // Check if tags are present
                    if (isArrayNotEmpty(updatedHotelInfo.groupingTags)) {
                        // If tags are present, update hotel info and isScandanavian in session
                        setHotelInfoInSession(updatedHotelInfo)
                        this.props.history.push(RouteConst.ROUTE_HOTEL_CONTACTS_PAGE)
                    } else {
                        // If tags are missing, get hotel info to get the updated tags
                        // which will be generated after PUT
                        this.props.onGet({ hotelCode: this.state.hotelCode })
                        this.setState({
                            isLoading: true,
                            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
                            actionPerformed: FormConst.ACTION_GET
                        })
                    }
                } else if (this.state.actionPerformed === FormConst.ACTION_GET) {
                    // GET hotel info happens after PUT when tags are missing
                    // Update hotel info and isScandanavian in session
                    setHotelInfoInSession(this.props.hotelInfoResponse)
                    this.props.history.push(RouteConst.ROUTE_HOTEL_CONTACTS_PAGE)
                }
            }
        }
    }

    render() {
        return (
            <div id='hotel-info-form' className='hotel-info-form'>
                <Formik
                    initialValues={this.state.initialValues}
                    validationSchema={this.validationSchema}
                    enableReinitialize={true}
                    onSubmit={(data, { setSubmitting, resetForm }) => {
                        setSubmitting(true)
                        this.handleSubmit(data)
                        setSubmitting(false)
                    }}>
                    {
                        ({ values, errors, touched, dirty, isSubmitting, isValid, resetForm, handleChange }) => (
                            <Form className='hotel-info-form-element'>
                                <p className='helper-text text-center'>{FormConst.HOTEL_INFO_HELPER_TEXT}</p>
                                <div id='hotel-info-form-fields' className='hotel-info-form-fields'>
                                    <Row>
                                        <Col xs={12} sm={12} xl={{ span: 5, offset: 0 }}>
                                            <TextInput
                                                id='property-phone-number'
                                                name='countryCode'
                                                type='tel'
                                                label='Property Phone Number'
                                                placeholder='CC'
                                                title='Country Code'
                                                suffix={
                                                    <>
                                                        <TextInput
                                                            id='area-code'
                                                            name='areaCode'
                                                            type='num'
                                                            label=' - '
                                                            title='Area Code'
                                                            placeholder='Area Code' />
                                                        <TextInput
                                                            id='phone-number'
                                                            name='phoneNumber'
                                                            type='tel'
                                                            label=' - '
                                                            title='Phone Number'
                                                            placeholder='Number' />
                                                    </>
                                                }
                                                isrequired='true' />
                                            <TextInput
                                                id='fax-number'
                                                name='faxCountryCode'
                                                type='tel'
                                                label='Fax Number'
                                                placeholder='CC'
                                                title='Country Code'
                                                suffix={
                                                    <>
                                                        <TextInput
                                                            id='fax-area-code'
                                                            name='faxAreaCode'
                                                            type='num'
                                                            label=' - '
                                                            title='Area Code'
                                                            placeholder='Area Code' />
                                                        <TextInput
                                                            id='fax-phone-number'
                                                            name='faxPhoneNumber'
                                                            type='tel'
                                                            label=' - '
                                                            title='Fax Number'
                                                            placeholder='Fax Number' />
                                                    </>
                                                }
                                                isrequired='true' />
                                            <TextInput id='generalManagerFirstName' name='generalManagerFirstName' type='text' label='General Manager First Name' isrequired='true' />
                                            <TextInput id='generalManagerLastName' name='generalManagerLastName' type='text' label='General Manager Last Name' isrequired='true' />
                                            <TextInput id='salesManagerFirstName' name='salesManagerFirstName' type='text' label='Sales Manager First Name' isrequired={values.salesManagerLastName ? 'true' : 'false'} />
                                            <TextInput id='salesManagerLastName' name='salesManagerLastName' type='text' label='Sales Manager Last Name' isrequired={values.salesManagerFirstName ? 'true' : 'false'} />
                                            {
                                                this.state.isHotelDomestic
                                                && (
                                                <TextInput id='femaId' name='femaId' type='text' label='FEMA ID' />
                                                )
                                            }
                                        </Col>
                                        <Col xs={12} sm={12} xl={{ span: 5, offset: 1 }} className='hotel-info-form-fields-small'>
                                            <SelectInput id='hotelOpeningType' name='hotelOpeningType' label='Hotel Opening Type' options={FormConst.HOTEL_OPENING_TYPES} isrequired='true' />
                                            <TextInput id='hotelOpeningDate' name='hotelOpeningDate' type='date' label='Hotel Opening Date' isrequired='true' />
                                            <TextInput id='numberOfRooms' name='numberOfRooms' type='number' label='Number of Rooms' isrequired='true' min='1' />
                                            <TextInput id='numberOfFloors' name='numberOfFloors' type='number' label='Number of Floors' isrequired='true' min='1' />
                                            <SelectInput id='hotelCurrency' name='hotelCurrency' type='tel' label='Hotel Currency' options={this.state.currencyOptions} isrequired='true' />
                                            <TextInput id='checkInTime' name='checkInTime' type='time' label='Check-in Time' isrequired='true' />
                                            <TextInput id='checkOutTime' name='checkOutTime' type='time' label='Check-out Time' isrequired='true' />
                                            <SelectInput id='hotelTimezone' name='hotelTimezone' label='Hotel Timezone' options={this.state.timezoneOptions} isrequired='true' />
                                            {
                                                values.isRatePlanConfigurationAvailable
                                                && <SelectInput
                                                    id='ratePlanConfigurationType'
                                                    name='ratePlanConfigurationType'
                                                    label='Rateplan configuration'
                                                    options={FormConst.RATE_PLAN_CONFIGURATION_TYPES}
                                                    onChange={
                                                        (e) => {
                                                            if (e.target.value === FormConst.RATE_PLAN_CONFIGURATION_TYPE_LINKED_VALUE) {
                                                                values.isLOSTiers = false
                                                            } else {
                                                                values.isLOSTiers = true
                                                            }
                                                            handleChange(e)
                                                        }
                                                    }
                                                    isrequired='true' />
                                            }
                                            {
                                                !this.state.isHotelDomestic
                                                && (
                                                    <>
                                                        <ToggleSwitch
                                                            id='isIncludeTaxes'
                                                            name='isIncludeTaxes'
                                                            label='Are your taxes included in rates?'
                                                            checked={values.isIncludeTaxes}
                                                            value={values.isIncludeTaxes}
                                                            options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                            onChange={handleChange}
                                                            isrequired='true' />
                                                        <ToggleSwitch
                                                            id='isChildrenStayFree'
                                                            name='isChildrenStayFree'
                                                            label='Children Stay Free?'
                                                            checked={values.isChildrenStayFree}
                                                            value={values.isChildrenStayFree}
                                                            options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                            onChange={handleChange}
                                                            isrequired='true' />
                                                        {
                                                            values.isChildrenStayFree
                                                            && <TextInput
                                                                id='maxChildAge'
                                                                name='maxChildAge'
                                                                type='number'
                                                                label='Max Child Age'
                                                                isrequired='true'
                                                                min='1' />
                                                        }
                                                        <ToggleSwitch
                                                            id='isTravelAgentCommission'
                                                            name='isTravelAgentCommission'
                                                            label='Travel Agent Commission?'
                                                            checked={values.isTravelAgentCommission}
                                                            value={values.isTravelAgentCommission}
                                                            options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                            onChange={handleChange}
                                                            isrequired='true' />
                                                        {
                                                            values.isTravelAgentCommission
                                                            && <TextInput
                                                                id='travelAgentCommission'
                                                                name='travelAgentCommission'
                                                                type='number'
                                                                label='Commission'
                                                                isrequired='true'
                                                                min='1' />
                                                        }
                                                    </>
                                                )
                                            }
                                        </Col>
                                    </Row>
                                    {
                                        values.isOfficeHoursConfigurable
                                        &&
                                        (
                                            <Row>
                                                <Col xs={12} lg={12} xl={11}>
                                                    <div className='office-hours'>
                                                        <p className='office-hours-title'>Front Desk Hours</p>
                                                        <SelectInput
                                                            id='officeHoursConfig'
                                                            name='officeHoursConfig'
                                                            label='Front Desk Hours Configuration'
                                                            options={FormConst.OFFICE_HOURS_OPTIONS}
                                                            isrequired='true' />
                                                        {
                                                            values.officeHoursConfig === 'Other'
                                                            && (
                                                                <>
                                                                    <ToggleSwitch
                                                                        id='isOfficeHoursSameAllDOW'
                                                                        name='isOfficeHoursSameAllDOW'
                                                                        label='Are the Front Desk hours same for all days of the week?'
                                                                        checked={values.isOfficeHoursSameAllDOW}
                                                                        value={values.isOfficeHoursSameAllDOW}
                                                                        options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                                        onChange={handleChange}
                                                                        isrequired='true' />
                                                                    {
                                                                        !values.isOfficeHoursSameAllDOW
                                                                            ? (
                                                                                <div className='office-hours-dow'>
                                                                                    <table className='table table-striped table-bordered d-none d-xl-table office-hours-table'>
                                                                                        <thead>
                                                                                            <tr>
                                                                                                <th>Monday</th>
                                                                                                <th>Tuesday</th>
                                                                                                <th>Wednesday</th>
                                                                                                <th>Thursday</th>
                                                                                                <th>Friday</th>
                                                                                                <th>Saturday</th>
                                                                                                <th>Sunday</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            <tr>
                                                                                                {
                                                                                                    Object.keys(this.daysOfWeek).map((day, index) => {
                                                                                                        return <td key={`dow-entry-${index}`}>
                                                                                                            <SelectInput id={`${day}24Config`}
                                                                                                                name={`${day}24Config`} label='Configuration'
                                                                                                                options={FormConst.OFFICE_HOURS_OPTIONS} isrequired='true' />

                                                                                                            {
                                                                                                                values[`${day}24Config`] === 'Other' &&
                                                                                                                (
                                                                                                                    <>
                                                                                                                        <TextInput id={`${day}OperatingHours`} name={`${day}OperatingHours.open`} type='time' label='Opens At' isrequired='true' />
                                                                                                                        <TextInput id={`${day}OperatingHours`} name={`${day}OperatingHours.close`} type='time' label='Closes At' isrequired='true' />
                                                                                                                    </>
                                                                                                                )
                                                                                                            }

                                                                                                        </td>
                                                                                                    })
                                                                                                }
                                                                                            </tr>
                                                                                        </tbody>
                                                                                    </table>
                                                                                    <MultiCard
                                                                                        id='office-hours-table'
                                                                                        className='d-block d-xl-none office-hours-card'
                                                                                        header='Front Desk Hours per day of week'
                                                                                        data={
                                                                                            Object.keys(this.daysOfWeek).map((day, index) => {
                                                                                                return {
                                                                                                    title: <b>{this.daysOfWeek[day]}</b>,
                                                                                                    text: <>

                                                                                                        <SelectInput id={`${day}24Config`}
                                                                                                            name={`${day}24Config`} label='Configuration'
                                                                                                            options={FormConst.OFFICE_HOURS_OPTIONS} isrequired='true' />

                                                                                                        {
                                                                                                            values[`${day}24Config`] === 'Other' && (
                                                                                                                <>

                                                                                                                    <TextInput id={`${day}OperatingHours`} name={`${day}OperatingHours.open`} type='time' label='Opens At' isrequired='true' />
                                                                                                                    <TextInput id={`${day}OperatingHours`} name={`${day}OperatingHours.close`} type='time' label='Closes At' isrequired='true' />

                                                                                                                </>
                                                                                                            )
                                                                                                        }
                                                                                                    </>
                                                                                                }
                                                                                            }
                                                                                            )
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            )
                                                                            : (
                                                                                <span className='dow-entry-common'>
                                                                                    <TextInput id='commonOperatingHoursOpen' name='commonOperatingHoursOpen' type='time' label='Opens At' isrequired='true' />
                                                                                    <TextInput id='commonOperatingHoursClose' name='commonOperatingHoursClose' type='time' label='Closes At' isrequired='true' />
                                                                                </span>
                                                                            )
                                                                    }
                                                                </>
                                                            )
                                                        }

                                                    </div>
                                                </Col>
                                            </Row>
                                        )
                                    }
                                </div>
                                <FormFooter
                                    form={SideNavEntryMapping.HOTEL_INFO}
                                    isSubmit
                                    submitName={FormConst.SAVE_BUTTON_TEXT}
                                    resetName={FormConst.RESET_BUTTON_TEXT}
                                    onReset={this.handleClearForm}
                                    submitDisabled={isSubmitting} />
                                <FormModal
                                    id='hotel-info-page-save-modal'
                                    title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                    hotelInfo={this.state.hotelInfo}
                                    body={<h6>{this.state.loadingMessage}</h6>}
                                    show={this.state.isLoading}
                                    isLoadingIndicator />
                                <FormModal
                                    id='hotel-info-page-reset-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={FormConst.MODAL_RESET_ACTION_TITLE}
                                    body={<h5>{FormConst.MODAL_RESET_ACTION_TEXT}</h5>}
                                    proceed={() => {
                                        this.resetFormData(resetForm)
                                    }}
                                    cancel={() => { this.setState({ showResetModal: false }) }}
                                    show={this.state.showResetModal} />
                                <FormModal
                                    id='hotel-info-page-error-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                    body={<h5>{this.state.errorMessage}</h5>}
                                    isError
                                    cancel={() => { this.setState({ showErrorModal: false }) }}
                                    show={this.state.showErrorModal} />
                            </Form>
                        )
                    }
                </Formik>
            </div>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        hotelInfoResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGet: (data) => dispatch(asyncMethod(FormConst.FORM_HOTEL_INFO_NAME, actionTypes.ASYNC_ACTIONS.GET, data)),
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_HOTEL_INFO_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(HotelInfo, SideNavEntryMapping.HOTEL_INFO))